import React, { Component } from 'react';
import { smallMediaQuery, mediumMediaQuery, largeMediaQuery } from '../../../common/utilities/sizeHelpers';
import matchMedia from 'matchmediaquery';

export function withScreenSize(WrappedComponent) {
    return class WithScreenSize extends Component {
        constructor(props) {
            super(props);
            this.state = this.getDimensionState();
            this.updateDimensions = this.updateDimensions.bind(this);
        }

        componentDidMount() {
            window.addEventListener('resize', this.updateDimensions);
        }

        componentWillUnmount() {
            window.removeEventListener('resize', this.updateDimensions);
        }
        
        updateDimensions() {
            this.setState(this.getDimensionState());
        }

        getDimensionState() {
            return { 
                width: window.innerWidth, 
                height: window.innerHeight,
                isMobile: matchMedia(smallMediaQuery).matches,
                isTablet: matchMedia(mediumMediaQuery).matches,
                isDesktop: matchMedia(largeMediaQuery).matches
            };
        }

        render() {
            const { width, height, isMobile, isTablet, isDesktop } = this.state;
            return <WrappedComponent 
                {...this.props}
                windowWidth={width}
                windowHeight={height} 
                isMobile={isMobile}
                isTablet={isTablet}
                isDesktop={isDesktop}
            />;
        }
    };
}